export class Modals {
  modals = {};

  constructor() {
    document.body.addEventListener('modals-ready', () => {
      let openOnLoad = document.body.dataset.modalOpened;
      if (openOnLoad) {
        let modal = this.getModal(openOnLoad);
        if (modal) {
          modal.open();
        }
      }
    });
    this.init(document);
    console.log('modals initialised');
  }

  async init(parent) {
    let elems = parent.querySelectorAll('.modal');
    return import(/* webpackChunkName: "modal" */ './modal').then((chunk) => {
      elems.forEach((elem) => {
        let id = elem.id;
        this.modals[id] = new chunk.Modal(id);
      });
      for (let key of Object.keys(this.modals)) {
        this.modals[key].initLinks(parent);
      }
      const event = new Event('modals-ready');
      document.body.dispatchEvent(event);
    });
  }

  getModal(id) {
    return this.modals[id];
  }
}
